import Icon from '../components/Icon.vue'

Icon.register({
  'paper-plane': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M476 3.2c17.3-10 39 4.6 35.6 24.8l-72 432c-2.6 15.3-18.8 24.2-33 18.2l-124.6-52.2-63.5 77.3c-14 17.1-42.5 7.8-42.5-15.8v-80.5l240.9-293.5c4.7-5.7-3.1-13.2-8.6-8.3l-287.3 253.2-106.3-44.6c-18-7.6-20.3-32.8-2.2-43.2z'
      }
    ]
  }
})
